import { useQuery } from '@tanstack/react-query'
import { programmesService } from '@/services/programmesService'

type ProgrammeNameMap = Record<string, string>

export function useProgrammeMap() {
  return useQuery<ProgrammeNameMap>({
    queryKey: ['programmes', 'map'],
    queryFn: async () => {
      const programmes = await programmesService.getProgrammes({
        requireAuth: true,
      })

      return programmes.reduce<ProgrammeNameMap>((acc, programme) => {
        if (programme.id) {
          acc[programme.id] = programme.title
        }
        return acc
      }, {})
    },
    staleTime: 1000 * 60 * 5,
  })
}

